module.exports = __webpack_public_path__ + "img/brasao-lg-4c72e7a705da2a8b531e9fd2a6177d2a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/brasao-lg.png
// module id = 110
// module chunks = 3